// extracted by mini-css-extract-plugin
export var heading = "history-hero-module--heading--C4Vfv";
export var paragraph__bottom = "history-hero-module--paragraph__bottom--olX7f";
export var paragraph__top = "history-hero-module--paragraph__top--raY54";